"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.usePplConfigurationQuery = void 0;
var _environment = require("@ori/environment");
var _fetching = require("@ori/fetching");
var _globalApiClientReact = require("@ori/global-api-client-react");
/* istanbul ignore file -- Api file */ const usePplConfigurationQuery = ()=>{
    const { tenant } = (0, _environment.useEnvironment)();
    return (0, _globalApiClientReact.useGetApplicationsPersonalProductsListConfiguration)({
        [_fetching.TENANT_CONTEXT]: tenant
    }, {
        swr: {
            revalidateIfStale: false,
            revalidateOnFocus: false,
            revalidateOnReconnect: false
        }
    });
};
exports.usePplConfigurationQuery = usePplConfigurationQuery;
